module.exports = __webpack_public_path__ + "img/canbadge_star_w56mm_line.0984bc6f.png";